import { render, staticRenderFns } from "./OpenProduct.vue?vue&type=template&id=38952141"
import script from "./OpenProduct.vue?vue&type=script&lang=js"
export * from "./OpenProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports